import Resource from './Resource';

/**
 * StoredView Resource
 */
class SavedDataView extends Resource
{
    constructor() {
        super('saved.view', ['saved-views']);
    }
}   
export let SavedDataViewResource = new SavedDataView();

/**
 * Task Schema
 */
export let SavedDataViewSchema = function(defaults = {}) {
    let schema = {
        id: null,
        name: null,
        namespace: null,
        filters: [],
        sortOrder: [],
        is_private: true
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
}